<template>
  <div v-for="group in commentsGroupedByElement" class="py-2 px-4">
    <div v-for="comment in group.comments" :key="comment.id" class="mb-2">
      <div class="d-flex align-center">
        <div class="font-weight-bold mr-1 d-flex align-center">
          <user-avatar v-if="comment.user_id" :user="{ id: comment.user_id }" show-username class="mr-1 mb-.5"></user-avatar>
        </div>
        <div class="ml-auto small text-medium-emphasis">{{ $filters.moment(comment.date_of_creation, 'fromNow') }}</div>
      </div>
      <span v-if="comment.text" ref="textcontent" v-html="enrichedContent(comment.text)"></span>
    </div>
    <div class="d-flex align-end">
      <planning-element-view v-if="group.element" :el="group.element" :title="group.element.display_title" class="flex-grow-1"
                             style="cursor: default; position: relative; font-size: 75%" disable-mini-element>
      </planning-element-view>
      <v-btn-icon v-if="elementUrl(group.element)" :title="$t('HOME.OPEN_IN_PROJECT')" :to="elementUrl(group.element)" size="x-small" class="ml-1">
        <v-icon>far fa-external-link</v-icon>
      </v-btn-icon>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'pinia';
  import useHomeUserStore from '@/stores/home-user';
  import PlanningElementView from '@/components/Planning/PlanningElementView.vue';
  import emojis from '@/components/ExchangeCenter/emojis';

  const rEmojis = new RegExp(`:(${emojis.join("|")}):`, "g");

  export default {
    components: {
      PlanningElementView,
    },
    props: {
      comments: { type: Array, required: true },
    },
    computed: {
      commentsGroupedByElement() {
        const commentsGroupedByElement = [];
        let lastElementId = null;
        this.comments.forEach((comment) => {
          const elementId = this.getCommentElementId(comment);
          if (commentsGroupedByElement.length && elementId == lastElementId) { // group
            commentsGroupedByElement.at(-1).comments.push(comment);
          } else {
            commentsGroupedByElement.push({ element: comment.element_id && this.planningElementsById.get(elementId) || null, comments: [comment] });
            lastElementId = elementId;
          }
        });
        return commentsGroupedByElement;
      },
      ...mapState(useHomeUserStore, ['planningElementsById']),
    },
    methods: {
      getCommentElementId(comment) {
        return `p${comment.planning_id}e${comment.element_id}`;
      },
      elementUrl(el) {
        const projectUrl = el?.getPlanning()?.meta.url;
        return projectUrl ? `${projectUrl}?el=${parseInt(el.id, 10)}` : null;
      },
      enrichedContent(text) {
        let enrichedText = text || "";
        enrichedText = enrichedText.replace(/(^|\s)(@[^ ]*)\b/g, '$1<a class="pointer" data-select="at" data-value="$2">$2</a>'); // @something
        enrichedText = enrichedText.replace(/(^|\s)(#[^ ]*)\b/g, '$1<a class="pointer" data-select="hashtag" data-value="$2">$2</a>'); // #something
        enrichedText = enrichedText.replace(/(https?:\/\/[a-zA-Z0-9._-]{4,})/gi, '<a href="$1" target="_blank" rel="noopener">$1</a>'); // http(s)://
        enrichedText = enrichedText.replace(/:\)/g, ':smile:').replace(/;\)/g, ':wink:')
          .replace(rEmojis, (match, txt) => `<i class='emoji emoji_${txt}' title=':${txt}:'>${txt}</i>`);
        return enrichedText;
      },
    },
  };
</script>
